import { style, group, animate, query } from '@angular/animations';
import { NgTemplateOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { input, viewChild, TemplateRef, inject, ElementRef, ChangeDetectorRef, Component, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { NgDocOverlayService, NgDocOverlayContainerComponent } from '@ng-doc/ui-kit';
const _c0 = ["image"];
const _c1 = ["*"];
function NgDocImageViewerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function NgDocImageViewerComponent_ng_template_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.overlayRef == null ? null : ctx_r1.overlayRef.close());
    });
    i0.ɵɵelement(1, "img", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.src(), i0.ɵɵsanitizeUrl)("alt", ctx_r1.alt());
  }
}
let NgDocImageViewerComponent = /*#__PURE__*/(() => {
  class NgDocImageViewerComponent {
    constructor() {
      this.src = input.required();
      this.alt = input.required();
      this.image = viewChild('image', {
        read: TemplateRef
      });
      this.overlay = inject(NgDocOverlayService);
      this.element = inject(ElementRef).nativeElement;
      this.changeDetectorRef = inject(ChangeDetectorRef);
    }
    clickEvent() {
      this.overlayRef?.close();
      const {
        width,
        height,
        top,
        left
      } = this.element.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const ratio = Math.min(windowWidth / width, windowHeight / height);
      const newWidth = width * ratio;
      const newHeight = height * ratio;
      this.overlayRef = this.overlay.open(this.image(), {
        overlayContainer: NgDocOverlayContainerComponent,
        positionStrategy: this.overlay.globalPositionStrategy().centerHorizontally().centerVertically(),
        scrollStrategy: this.overlay.scrollStrategy().block(),
        hasBackdrop: true,
        backdropClass: 'ng-doc-blur-backdrop',
        openAnimation: [style({
          position: 'fixed',
          width,
          height,
          top,
          left,
          transform: 'translate(0%, 0)'
        }), group([animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
          width: `${newWidth}px`,
          height: `${newHeight}px`,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        })), query('.ng-doc-image-container', [style({
          padding: 0
        }), animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
          padding: '16px'
        }))])])],
        closeAnimation: [style({
          position: 'fixed',
          width: `${newWidth}px`,
          height: `${newHeight}px`,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }), group([animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
          width,
          height,
          top,
          left,
          transform: 'translate(0%, 0)'
        })), query('.ng-doc-image-container', animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({
          padding: 0
        })))])]
      });
      this.overlayRef.afterClose().subscribe(() => {
        this.overlayRef = undefined;
        this.changeDetectorRef.markForCheck();
      });
    }
    static {
      this.ɵfac = function NgDocImageViewerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocImageViewerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocImageViewerComponent,
        selectors: [["ng-doc-image-viewer"]],
        viewQuery: function NgDocImageViewerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.image, _c0, 5, TemplateRef);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        hostVars: 1,
        hostBindings: function NgDocImageViewerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function NgDocImageViewerComponent_click_HostBindingHandler() {
              return ctx.clickEvent();
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-opened", !!ctx.overlayRef);
          }
        },
        inputs: {
          src: [1, "src"],
          alt: [1, "alt"]
        },
        ngContentSelectors: _c1,
        decls: 3,
        vars: 0,
        consts: [["image", ""], [1, "ng-doc-image-container", 3, "click"], [1, "ng-doc-scaled-image", 3, "src", "alt"]],
        template: function NgDocImageViewerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
            i0.ɵɵtemplate(1, NgDocImageViewerComponent_ng_template_1_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
        },
        styles: ["[_nghost-%COMP%]{display:inline-block;cursor:zoom-in;transition:var(--ng-doc-transition)}[data-opened=true][_nghost-%COMP%] >   img{opacity:0}[_nghost-%COMP%] >   img{max-width:100%;vertical-align:middle;border-radius:var(--ng-doc-base-gutter);overflow:hidden}.ng-doc-image-container[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;padding:calc(var(--ng-doc-base-gutter) * 2);width:100%;height:100%}.ng-doc-image-container[_ngcontent-%COMP%]   .ng-doc-scaled-image[_ngcontent-%COMP%]{cursor:zoom-out;width:100%;height:100%}"],
        changeDetection: 0
      });
    }
  }
  return NgDocImageViewerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocImageViewerComponent };
